import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Users FETCH mutations on PTOS
  fetchPtos: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPtos';

    commit(`${mutationPrefix}Pending`);

    return api.fetchPtos(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Users FETCH mutations on PTOS
  fetchSinglePto: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSinglePto';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSinglePto(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on PTOS
  createPto: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createPto';

    commit(`${mutationPrefix}Pending`);

    return api.createPto(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on PTOS
  updatePto: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updatePto';

    commit(`${mutationPrefix}Pending`, id);

    return api.updatePto(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on PTOS
  deletePto: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deletePto';

    commit(`${mutationPrefix}Pending`, id);

    return api.deletePto(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, response);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses UPDATE mutations on PTOs
  changeStatus: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'changeStatus';

    commit(`${mutationPrefix}Pending`, id);

    return api.changeStatus(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses FETCH mutations on PTOs
  fetchRejectedPtos: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchRejectedPtos';

    commit(`${mutationPrefix}Pending`);

    return api.fetchRejectedPtos(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on PTOs
  fetchPendingPtos: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPendingPtos';

    commit(`${mutationPrefix}Pending`);

    return api.fetchPendingPtos(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openFormModal: ({ commit }) => {
    commit('openFormModal');
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/pto/actions.js